var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6606 17.8849C8.44044 19.2199 3.93708 16.881 2.60209 12.6608C1.2671 8.44062 3.60602 3.93726 7.8262 2.60227C12.0464 1.26728 16.5498 3.6062 17.8847 7.82638C19.2197 12.0466 16.8808 16.5499 12.6606 17.8849Z",
    fill: "url(#paint0_linear_835_2579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98523 3.10499C4.05397 4.34858 1.85804 8.56046 3.10481 12.5018C4.35158 16.4431 8.57034 18.6258 12.5016 17.3822C16.4329 16.1386 18.6256 11.9167 17.382 7.98541C16.1384 4.05415 11.9265 1.85822 7.98523 3.10499ZM7.8262 2.60227C12.049 1.26644 16.5489 3.60355 17.8847 7.82638C19.2206 12.0492 16.8835 16.5491 12.6606 17.8849C8.43779 19.2207 3.93792 16.8836 2.60209 12.6608C1.26626 8.43797 3.60337 3.9381 7.8262 2.60227Z",
    fill: "url(#paint1_linear_835_2579)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1998 16.4274C15.6082 15.3492 17.5054 11.6964 16.4272 8.28793C15.349 4.8795 11.6961 2.98232 8.28769 4.06053C4.87926 5.13873 2.98208 8.79157 4.06028 12.2C5.13849 15.6084 8.79132 17.5056 12.1998 16.4274ZM8.38311 4.36216C11.6307 3.33484 15.0982 5.13579 16.1255 8.38335C17.1528 11.6309 15.3519 15.0985 12.1043 16.1258C8.85678 17.1531 5.38923 15.3521 4.36191 12.1046C3.3346 8.85702 5.13554 5.38947 8.38311 4.36216Z",
    fill: "url(#paint2_linear_835_2579)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0466 6.60293L8.95253 8.53674L8.5009 9.38511L8.43363 9.31647C8.22548 9.42933 7.86511 9.2368 7.65518 9.17355C7.06049 8.99434 6.31042 8.67147 5.69335 8.64887L5.69259 8.75107C5.95436 8.90298 6.07249 9.40838 6.2025 9.6747L7.27082 11.863C7.38163 12.09 7.5112 12.5694 7.7183 12.7171C7.84419 12.8068 8.12452 12.7551 8.27258 12.7562C8.74897 12.7597 9.22057 12.729 9.69621 12.7327C10.3493 12.7378 11.006 12.7765 11.6616 12.7813C11.8725 12.7829 12.2347 12.856 12.428 12.7664C12.6685 12.6548 12.8642 12.0026 12.9825 11.769C13.3253 11.0923 13.646 10.4047 13.9975 9.73244C14.167 9.40827 14.4373 9.04145 14.505 8.68007C14.3848 8.69499 14.1839 8.71418 14.1648 8.8479C13.8422 8.78793 13.489 8.95181 13.1805 9.04417C12.6762 9.19514 12.1605 9.30361 11.6524 9.44252C11.549 9.07913 11.2701 8.73985 11.0875 8.41096C10.7697 7.83874 10.4937 7.07952 10.0466 6.60293Z",
    fill: "#FFEAB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_2579",
    x1: 13.9374,
    y1: 3.13115,
    x2: 6.54942,
    y2: 17.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_2579",
    x1: 13.3041,
    y1: 2.83476,
    x2: 7.18271,
    y2: 17.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#FEE6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#FDD792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FBBE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#F89C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F57C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#F67A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#FA7621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_2579",
    x1: 14.6195,
    y1: 5.45954,
    x2: 5.86793,
    y2: 15.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4511E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.9cdda4fc0a9edb68c9707964510d537f.svg";
export { ForwardRef as ReactComponent };